import PolicyLayout from "./PolicyLayout";

export default function RefundPage() {
  return (
    <PolicyLayout
      title="Refund, Return & Cancellation Policy"
      updated="December 2025"
      testId="refund-page"
    >
      <p>
        We want you (and the little one receiving your Me Amor box) to be
        delighted. This policy sets out how refunds, returns and
        cancellations work — and preserves your rights under the New Zealand
        Consumer Guarantees Act 1993.
      </p>

      <h2>1. Faulty, damaged or incorrect items</h2>
      <p>
        If your box arrives damaged, incomplete or contains an item that is
        faulty, please email us at{" "}
        <a href="mailto:empower.meamor@gmail.com">
          empower.meamor@gmail.com
        </a>{" "}
        <strong>within 14 days of delivery</strong> with:
      </p>
      <ul>
        <li>Your order confirmation email or order number</li>
        <li>A description of the issue</li>
        <li>Clear photos of the damaged or incorrect item</li>
      </ul>
      <p>
        We will arrange one of the following, at our discretion and in
        accordance with the Consumer Guarantees Act 1993: a replacement of
        the affected item(s), a partial refund, or a full refund.
      </p>

      <h2>2. Change of mind</h2>
      <p>
        We are not required to accept returns for change of mind. If you
        wish to return an unopened, unused box in its original condition,
        please contact us within 7 days of delivery. If accepted, you will
        be responsible for return shipping and any refund issued will
        exclude the original shipping fee.
      </p>

      <h2>3. Personalised items</h2>
      <p>
        Personalised items (currently the Birthday Kit personalisation
        add-on) cannot be returned or refunded for change of mind. Faulty
        or incorrect personalised items are still covered by your Consumer
        Guarantees Act rights — please contact us.
      </p>

      <h2>4. Subscription cancellations (Seasonal Subscription Box)</h2>
      <p>
        You may cancel your Seasonal Subscription Box at any time.
        To cancel:
      </p>
      <ul>
        <li>
          Email{" "}
          <a href="mailto:empower.meamor@gmail.com">
            empower.meamor@gmail.com
          </a>{" "}
          with the subject line &ldquo;Cancel subscription&rdquo; and the
          email address on your order.
        </li>
        <li>
          Cancellations received <strong>at least 7 days before</strong> the
          next billing date will prevent the next box from being charged.
        </li>
        <li>
          If you cancel within 7 days of the next billing date, your next
          box may still ship — that final box is non-refundable but no
          further boxes will be billed.
        </li>
      </ul>

      <h2>5. Missed / undelivered subscription boxes</h2>
      <p>
        If a subscription box does not arrive within our expected delivery
        window (see the{" "}
        <a href="/shipping">Shipping &amp; Delivery Policy</a>), let us know
        within 30 days of the expected delivery date and we&apos;ll
        investigate with the courier and resend or refund as appropriate.
      </p>

      <h2>6. How refunds are issued</h2>
      <p>
        Approved refunds are returned to the original payment method via
        Stripe. Refunds typically appear in your account within 5–10 business
        days depending on your bank or card issuer.
      </p>

      <h2>7. Contact</h2>
      <p>
        All refund, return and cancellation requests are handled via email:{" "}
        <a href="mailto:empower.meamor@gmail.com">
          empower.meamor@gmail.com
        </a>
        . We aim to respond within 2 business days.
      </p>
    </PolicyLayout>
  );
}
